import { isValidNumber } from "../isValidNumber/isValidNumber";

export const isValidPrice = (value: unknown): value is number => {
  return isValidNumber(value) && value >= 0;
};
